var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderSteps',{attrs:{"title":"Add assets","back-path":-1}}),_c('Assets')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }